import { ReactElement } from 'react';
import CurrentUserDetail from '../../../model/currentuser/CurrentUserDetail';
import { UserRoleEnum } from '../../../model/currentuser/UserRole';

interface Props {
  pouzivatel: CurrentUserDetail;
  children: ReactElement;
  allowForRoles?: Array<UserRoleEnum>;
  additionalCheck?: boolean;
  elseChildren?: ReactElement;
}

const isAuthorized = (allowForRoles: Array<UserRoleEnum>, user: CurrentUserDetail): boolean => {
  const userRoles = user == null ? [] : user.roles;
  if (!allowForRoles) {
    return true;
  }
  if (!userRoles || userRoles.length === 0 || allowForRoles.length === 0) {
    return false;
  }
  return userRoles.some(role => allowForRoles.includes(role));
};

const SecuredComponent = ({
  children, allowForRoles, pouzivatel, additionalCheck = true, elseChildren = null,
}: Props): ReactElement => {
  if (isAuthorized(allowForRoles, pouzivatel) && additionalCheck) {
    return children;
  }

  return elseChildren;
};

export default SecuredComponent;
